import React, { useCallback, useEffect, useRef, } from "react";
import { autoTextSize } from "./auto-text-size-standalone";
/**
 * Make text fit container, prevent overflow and underflow.
 */
export function AutoTextSize({ mode, minFontSizePx, maxFontSizePx, fontSizePrecisionPx, as: Comp = "div", // TODO: The `...rest` props are not typed to reflect another `as`.
children, ...rest }) {
    const updateTextSizeRef = useRef();
    useEffect(() => updateTextSizeRef.current?.(), [children]);
    const refCallback = useCallback((innerEl) => {
        updateTextSizeRef.current?.disconnect();
        const containerEl = innerEl?.parentElement;
        if (!innerEl || !containerEl)
            return;
        updateTextSizeRef.current = autoTextSize({
            innerEl,
            containerEl,
            mode,
            minFontSizePx,
            maxFontSizePx,
            fontSizePrecisionPx,
        });
    }, [mode, minFontSizePx, maxFontSizePx, fontSizePrecisionPx]);
    return (React.createElement(Comp, { ref: refCallback, ...rest }, children));
}
//# sourceMappingURL=auto-text-size-react.js.map